module.exports = __webpack_public_path__ + "img/pin.e98f7f99.svg";